@if (isLimitReached) {
  <span>
    {{
      '::GenAIFeatureUsage:Notification:FeatureUsage:LimitReached'
        | abpLocalization
          : payloadData?.featureName
          : payloadData?.currentUsageCount
          : payloadData?.totalLimitCount
    }}
  </span>
}

@if (!isLimitReached) {
  <span>
    {{
      '::GenAIFeatureUsage:Notification:FeatureUsage:LimitNotReached'
        | abpLocalization
          : payloadData?.featureName
          : payloadData?.percentage
          : payloadData?.percentage
          : (payloadData?.period ? payloadData?.period : ' ')
          : payloadData?.currentUsageCount
          : payloadData?.totalLimitCount
    }}
  </span>
}
